<template>
  <main class="pt-16 bg-gradient-to-b from-gray-300 via-gray-200 to-gray-300 relative">
    <!-- Popup de confirmation de mise à jour -->
    <transition name="popup-fade">
      <div
        v-if="popup"
        class="fixed inset-0 bg-black/70 flex justify-center items-center z-50"
        @click.self="reload"
      >
        <transition name="popup-scale" appear>
          <div v-if="popup" class="w-[90%] max-w-md bg-white rounded-lg shadow-xl p-6 text-center relative">
        <button
          @click="reload"
          class="absolute top-3 right-4 text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>
        <div class="mb-4">
          <div class="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
            <svg class="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h2 class="text-xl font-bold text-gray-900 mb-2">Participation mise à jour</h2>
          <p class="text-gray-600 text-sm mb-4">
            Vos informations ont été enregistrées avec succès.
          </p>
        </div>
        <button
          @click="reload"
          class="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
        >
          Fermer
        </button>
          </div>
        </transition>
      </div>
    </transition>

    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
      <!-- Loader pendant la vérification de la date de régularisation -->
      <div v-if="checking" class="flex justify-center items-center py-20">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
      </div>

      <!-- Période de régularisation terminée -->
      <div v-else-if="regulEnded" class="max-w-3xl mx-auto">
        <div class="bg-white rounded-2xl shadow-xl p-8 sm:p-10 md:p-12">
          <div class="text-center">
            <div class="mx-auto w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-100 flex items-center justify-center mb-6">
              <svg class="w-10 h-10 sm:w-12 sm:h-12 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>

            <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              La période de régularisation est terminée
            </h1>

            <p class="text-gray-600 text-base sm:text-lg leading-relaxed mb-6">
              La période de régularisation des dossiers s'est terminée le
              <strong class="text-gray-900">{{ dateFinRegulLabel }}</strong>.
              Il n'est plus possible de compléter ou de modifier votre participation.
            </p>

            <router-link
              to="/"
              class="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 sm:py-4 px-8 sm:px-10 rounded-full transition-all hover:shadow-lg text-sm sm:text-base"
            >
              <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
              </svg>
              <span>Retour à l'accueil</span>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Suivi de participation -->
      <div v-else class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
        <!-- Colonne gauche - Formulaire de status -->
        <div class="bg-white rounded-lg shadow-lg p-6">
          <h1 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2 text-center">
            Suivi de participation
          </h1>
          <p class="text-gray-600 text-center text-sm mb-6">
            Consultez et complétez votre dossier de participation
          </p>

          <transition name="fade">
            <Form
              v-if="form_id"
              id="statusform"
              class="w-full mx-auto form-status"
              :form_id="form_id"
              :uid="uid"
              :submission_id="submission_id"
              :server="server"
              v-on:results="getResult"
              v-on:form_submit_loading="loading"
              @on_error="viewError"
              :hideError="hiderror"
            />
          </transition>

          <div v-if="load" class="flex justify-center items-center py-4">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          </div>
        </div>

        <!-- Colonne droite - Image -->
        <div class="hidden lg:flex items-start justify-center pt-8">
          <img
            v-if="phoneImage"
            :src="phoneImage"
            alt="Xiaomi Redmi Note 15"
            class="max-h-96 w-auto object-contain drop-shadow-2xl"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "StatusView",
  data() {
    return {
      phoneImage: null,
      hiderror: true,
      load: false,
      popup: false,
      checking: true,
      regulEnded: false,
      dateFinRegul: null,
      operationId: "691aec3fe85184ee57dbd4c4",
      form_id: "691aec3fe85184ee57dbd516",
      server: "https://api-gabarit.promo.dev",
    };
  },
  computed: {
    submission_id() {
      return this.$route.params.id;
    },
    uid() {
      return this.$route.params.uid;
    },
    dateFinRegulLabel() {
      if (!this.dateFinRegul) return "";
      return new Date(this.dateFinRegul).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
  async mounted() {
    try {
      this.phoneImage = require("@/assets/images/xiaomi-15-ultra.png");
    } catch (e) {
      this.phoneImage = null;
    }
    await this.checkRegulDate();
  },
  methods: {
    async checkRegulDate() {
      try {
        const { data } = await axios.get(
          `${this.server}/api/v2/formdata/${this.operationId}`
        );
        if (data && data.date_fin_regule) {
          this.dateFinRegul = data.date_fin_regule;
          this.regulEnded =
            new Date(data.date_fin_regule).getTime() < Date.now();
        }
      } catch (e) {
        console.error("Erreur récupération date de régularisation:", e);
      } finally {
        this.checking = false;
      }
    },
    getResult(result) {
      this.load = false;
      if (result) {
        this.popup = true;
      }
    },
    reload() {
      this.popup = false;
      setTimeout(() => {
        location.reload();
      }, 350);
    },
    viewError(error) {
      this.load = false;
      console.log(error);
      alert("Une erreur est survenue, veuillez réessayer.");
    },
    loading() {
      this.load = true;
    },
  },
};
</script>

<style>
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Masquer les étapes */
.form-status .step {
  display: none !important;
}

/* Conteneur général du formulaire */
.form-status .form-step {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Labels */
.form-status label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}

.form-status .required-star {
  color: #ef4444;
}

/* Inputs */
.form-status input[type="text"],
.form-status input[type="email"],
.form-status input[type="tel"],
.form-status select {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-status input[type="text"]:focus,
.form-status input[type="email"]:focus,
.form-status input[type="tel"]:focus,
.form-status select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

/* Form items wrapper */
.form-status .form_item {
  margin-bottom: 12px;
}

/* Info text */
.form-status .info {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}

/* Mention */
.form-status .mention {
  font-size: 12px;
  color: #6b7280;
  margin-top: 16px;
  margin-bottom: 8px;
}

/* Messages d'erreur */
.form-status .error {
  color: #ef4444;
  font-size: 12px;
  text-align: left;
  margin-top: 6px;
  line-height: 1.3;
  font-weight: 500;
}

/* Upload wrapper */
.form-status .upload-btn-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 0;
  margin: 0;
}

.form-status .upload-btn {
  background-color: #f97316;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  padding: 10px 16px;
  margin-top: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.form-status .upload-btn:hover {
  background-color: #ea580c;
}

.form-status .upload-btn-wrapper input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

/* Boutons */
.form-status .builder-buttons {
  margin-top: 20px;
}

.form-status button[type="submit"],
.form-status .suivant {
  width: 100%;
  background-color: #f97316;
  color: white;
  font-weight: 600;
  padding: 14px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 16px;
}

.form-status button[type="submit"]:hover,
.form-status .suivant:hover {
  background-color: #ea580c;
}

/* Captcha caché */
.form-status .captcha {
  display: none !important;
}

/* Popup animations */
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}

.popup-fade-enter,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-scale-enter-active {
  animation: popup-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.popup-scale-leave-active {
  animation: popup-out 0.25s ease-in;
}

@keyframes popup-in {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes popup-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}
</style>
